import { useEffect, useState } from 'react'
import { MenuItem, TextField } from '@mui/material'
import { adminService, type TargetingRule } from '../../services/adminService'

/**
 * A dropdown to assign a targeting rule to an item (session/content/form).
 * "Everyone" maps to null (no rule).
 */
export default function TargetingSelect({
  eventId,
  value,
  onChange,
}: {
  eventId: string
  value: string | null
  onChange: (ruleId: string | null) => void
}) {
  const [rules, setRules] = useState<TargetingRule[]>([])

  useEffect(() => {
    adminService
      .listRules(eventId)
      .then(setRules)
      .catch(() => setRules([]))
  }, [eventId])

  return (
    <TextField
      select
      fullWidth
      label="Visible to"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
      helperText={
        rules.length === 0
          ? 'No targeting rules yet — create them on the Targeting tab.'
          : undefined
      }
    >
      <MenuItem value="">Everyone</MenuItem>
      {rules.map((r) => (
        <MenuItem key={r.id} value={r.id}>
          {r.name}
        </MenuItem>
      ))}
    </TextField>
  )
}
